import { ArrowLeft, ArrowRight } from 'lucide-react';

interface StepContainerProps {
  stepIndex: number;
  totalSteps: number;
  title: string;
  description?: React.ReactNode;
  onBack?: () => void;
  onNext?: () => void;
  nextDisabled?: boolean;
  nextLabel?: string;
  children: React.ReactNode;
  showNext?: boolean;
}

export function StepContainer({
  stepIndex,
  totalSteps,
  title,
  description,
  onBack,
  onNext,
  nextDisabled = false,
  nextLabel = 'Siguiente',
  children,
  showNext = true,
}: StepContainerProps) {
  return (
    <div className="h-full overflow-y-auto">
      <div className="min-h-full flex flex-col">
        {/* Progress */}
        <div className="flex-shrink-0">
          <div className="w-full bg-gray-100 rounded-full h-2 overflow-hidden">
            <div
              className="bg-primary h-full rounded-full transition-all duration-500 ease-out"
              style={{ width: `${((stepIndex + 1) / totalSteps) * 100}%` }}
            />
          </div>
        </div>

        {/* Center block: title + description + content */}
        <div className="flex-1 flex flex-col justify-center py-6">
          {/* Title */}
          <h2 className="text-2xl md:text-3xl font-bold text-gray-900 leading-tight flex-shrink-0">
            {title}
          </h2>

          {/* Description */}
          {description && (
            <div className="text-gray-500 text-base md:text-lg mt-3 leading-relaxed flex-shrink-0">
              {description}
            </div>
          )}

          {/* Content */}
          <div className="mt-8 flex-shrink-0">
            {children}
            
            {/* Navigation - directamente después del contenido en el flujo HTML */}
            <div className="mt-6 space-y-2">
              {showNext && onNext && (
                <button
                  type="button"
                  onClick={onNext}
                  disabled={nextDisabled}
                  className="w-full bg-primary text-white py-4 rounded-xl text-lg font-semibold disabled:opacity-30 disabled:cursor-not-allowed hover:bg-primary/90 active:scale-[0.98] transition-all flex items-center justify-center gap-2"
                >
                  {nextLabel}
                  <ArrowRight className="w-5 h-5" />
                </button>
              )}
              {onBack && (
                <button
                  type="button"
                  onClick={onBack}
                  className="w-full flex items-center justify-center gap-2 text-gray-400 hover:text-gray-600 py-3 text-sm transition-colors"
                >
                  <ArrowLeft className="w-4 h-4" />
                  Volver al paso anterior
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
